import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  TextField,
  Button,
  Stack,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import axios from "axios";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";

const API_URL = process.env.REACT_APP_API_URL;

const EditRequest = () => {
  const { id } = useParams();
  const [form, setForm] = useState({});

  // Fetch existing request data
  useEffect(() => {
    if (!id) return;
    axios
      .post(`${API_URL}/edit-requests/get/`, { id })
      .then((res) => setForm(res.data))
      .catch((err) => {
        console.error("Fetch error:", err.response?.data || err);
        alert("Failed to load request data");
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = async () => {
    try {
      const payload = {
  ...form,
  id,
  media: form.media || "",  // send existing media
  media_key: form.media_key || "",
  price: form.price === "" ? null : parseFloat(form.price),
  duration: form.duration === "" ? null : parseFloat(form.duration),
  startTime: form.startTime || null,
  selectedDate: form.selectedDate || null,
  is_active: form.is_active || false,
  status: form.status || "pending",
};


      await axios.patch(`${API_URL}/edit-requests/`, payload);
      alert("Request updated successfully");
    } catch (err) {
      console.error("Update error:", err.response?.data || err);
      alert("Update failed");
    }
  };

  return (
    <div>
      <Header1 />
      <Stack spacing={2} maxWidth={700} mx="auto" my={4}>
        <TextField
          label="Price"
          name="price"
          value={form.price || ""}
          onChange={handleChange}
        />
        <TextField
          label="Language"
          name="language"
          value={form.language || ""}
          onChange={handleChange}
        />
        <TextField
          label="Description"
          name="description"
          multiline
          rows={3}
          value={form.description || ""}
          onChange={handleChange}
        />
        <TextField
          type="time"
          label="Start Time"
          name="startTime"
          InputLabelProps={{ shrink: true }}
          value={form.startTime || ""}
          onChange={handleChange}
        />
        <TextField
          label="Duration"
          name="duration"
          value={form.duration || ""}
          onChange={handleChange}
        />
        <TextField
          type="date"
          label="Selected Date"
          name="selectedDate"
          InputLabelProps={{ shrink: true }}
          value={form.selectedDate || ""}
          onChange={handleChange}
        />
        <TextField
          label="Meeting Link"
          name="meeting_link"
          value={form.meeting_link || ""}
          onChange={handleChange}
        />
        <TextField
          label="Coupon Code"
          name="coupon_code"
          value={form.coupon_code || ""}
          onChange={handleChange}
        />
        <TextField
          label="Media Key"
          name="media_key"
          value={form.media_key || ""}
          onChange={handleChange}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={form.is_active || false}
              onChange={handleCheckbox}
              name="is_active"
            />
          }
          label="Is Active"
        />
        <Typography variant="subtitle1" color="textSecondary">
  Current Status: {form.status || "pending"}
</Typography>
        <TextField
          select
          label="Status"
          name="status"
          value={form.status || "pending"}
          onChange={handleChange}
        >
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="approved">Approved</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
        </TextField>
        <Button variant="contained" onClick={handleSubmit}>
          Update Request
        </Button>
      </Stack>
      <Footer2 />
    </div>
  );
};

export default EditRequest;
